module.exports = __webpack_public_path__ + "img/tm.26863b57.svg";